import { Controller } from '@hotwired/stimulus'
import { confirmDialog, errorDialog } from '../helpers/swal_helper'

export default class extends Controller {
  static values = {
    expiresAt: Number,
    checkUrl: String
  }

  connect() {
    this.checkOnFocus = this.checkSession.bind(this)
    window.addEventListener('focus', this.checkOnFocus)
    this.setWarningTimer()
    this.setExpiryTimer()
  }

  disconnect() {
    window.removeEventListener('focus', this.checkOnFocus)
    clearTimeout(this.warningTimeout)
    clearTimeout(this.expiryTimeout)
  }

  setWarningTimer() {
    const sessionExpiresAt = this.expiresAtValue;
    const now = Date.now();
    const warningTime = sessionExpiresAt - (2 * 60 * 1000);
    const timeUntilWarning = warningTime - now;

    console.debug("Session Expires At:", new Date(sessionExpiresAt));

    if (timeUntilWarning > 0) {
      this.warningTimeout = setTimeout(() => {
        this.showRenewDialog();
      }, timeUntilWarning);
    }
  }

  setExpiryTimer() {
    const sessionExpiresAt = this.expiresAtValue
    const now = Date.now()
    const timeUntilExpiry = sessionExpiresAt - now

    if (timeUntilExpiry > 0) {
      this.expiryTimeout = setTimeout(() => {
        this.showExpiredDialog()
      }, timeUntilExpiry)
    }
  }

  async checkSession() {
    const now = Date.now();
    // Only check if expiry is within the next 5 minutes or already passed
    if (this.expiresAtValue - now < 5 * 60 * 1000) { // 5 minutes
      try {
        const res = await fetch(this.checkUrlValue, {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({})
        });

        if (res.status === 401 || res.redirected) {
          this.showExpiredDialog();
        } else {
          // Session is still active, extend the expiry time by 15 minutes
          this.expiresAtValue = now + (15 * 60 * 1000); // Extend by 15 minutes from now
          console.debug("Session renewed. New Expires At:", new Date(this.expiresAtValue));
          // Reset timers based on the new expiry time
          this.setWarningTimer();
          this.setExpiryTimer();
        }
      } catch (err) {
        console.error("Session check failed:", err);
        this.showExpiredDialog();
      }
    }
  }

  async showRenewDialog() {
    const confirmed = await confirmDialog({
      title: 'Would you like to renew it?',
      text: 'Your session will expire in 2 minutes.'
    })

    if (confirmed) {
      window.location.reload()
    }
  }

  showExpiredDialog() {
    errorDialog('Session Expired', 'Please sign in again.').then(() => {
      window.location.href = '/users/sign_in'
    })
  }
}
